var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('notifications',{attrs:{"group":"general-notification","position":"top right","width":"400","animation-type":"velocity","duration":4000}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }